export const GET_MENU = "GET_MENU";
export const GET_CATEGORY = "GET_CATEGORY";
export const GET_CATEGORIES = "GET_CATEGORIES";
export const GET_SUB_CATEGORIES = "GET_SUB_CATEGORIES";
export const GET_TITLES = "GET_TITLES";